<template>
  <div class='main login-page'>
    <a-form :form='form' class='user-layout-login' ref='formLogin' id='formLogin'>
      <a-tabs
        :activeKey='customActiveKey'
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change='handleTabClick'>
        <a-tab-pane key='tab1' :tab="$t('tip.loginTitle')">
          <a-form-item style='position:relative' v-if='langList.length'>
            <a-select size='large' :value='defaultLocal' @change='changeLang' placeholder='请选择系统语言'>
              <a-select-option :value='item.languageCode' v-for='(item, index) in langList' :key='index'>
                {{ item.languageName }}
              </a-select-option>
            </a-select>
            <a-icon type='flag' style='position:absolute;left:12px;top:50%;transform:translateY(-50%);z-index:99;color:rgba(0,0,0,.25)' />
          </a-form-item>
          <a-form-item>
            <a-input
              size='large'
              v-decorator="['username',{initialValue:'', rules: validatorRules.username.rules}]"
              type='text'
              :placeholder="$t('label.pleaseEnterAUsername')">
              <a-icon slot='prefix' type='user' :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              v-decorator="['password',{initialValue:'', rules: validatorRules.password.rules}]"
              size='large'
              type='password'
              autocomplete='false'
              :placeholder="$t('label.pleaseEnterAPassword')">
              <a-icon slot='prefix' type='lock' :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

          <a-row :gutter='0'>
            <!--换滑块-->
            <!--<a-col :span="16">
              <a-form-item>
                <a-input
                  v-decorator="['inputCode',validatorRules.inputCode]"
                  size="large"
                  type="text"
                  @change="inputCodeChange"
                  placeholder="请输入验证码">
                  <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8" style="text-align: right">
              <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode"/>
              <img v-else style="margin-top: 2px;" src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>
              &lt;!&ndash;<j-graphic-code @success="generateCode" ref="jgraphicCodeRef" style="float: right" remote></j-graphic-code>&ndash;&gt;
            </a-col>-->
            <a-col :span='24'>
              <!-- <j-slider @onSuccess="sliderSuccess"></j-slider> -->
              <drag-verify
                :width='368'
                :height='34'
                :text="$t('tip.dragVerify')"
                :success-text="$t('tip.dragSuccess')"
                background='rgb(232, 232, 232)'
                progress-bar-bg='rgb(122, 194, 60)'
                completed-bg='rgb(122, 194, 60)'
                handler-bg='#fff'
                text-size='14px'
                handler-icon='fa fa-angle-double-right'
                success-icon='fa fa-check'
                :circle='false'
                @passcallback='sliderSuccess'
                ref='Verify'
              />
              <span style='color: red;'>{{ slideredMsg }}</span>
            </a-col>
          </a-row>


        </a-tab-pane>
        <!--todo 暂无短信服务-->
        <!--<a-tab-pane key="tab2" tab="手机号登陆">
          <a-form-item>
            <a-input
              v-decorator="['mobile',validatorRules.mobile]"
              size="large"
              type="text"
              placeholder="手机号">
              <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>

          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input
                  v-decorator="['captcha',validatorRules.captcha]"
                  size="large"
                  type="text"
                  placeholder="请输入验证码">
                  <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')"></a-button>
            </a-col>
          </a-row>
        </a-tab-pane>-->
      </a-tabs>
      <a-form-item>
        <a-checkbox v-decorator="['rememberMe', {initialValue: true, valuePropName: 'checked'}]">{{ $t('tip.automaticLogin') }}</a-checkbox>
        <!-- <router-link :disabled="true" :to="{ name: 'alteration'}" class="forge-password" style="float: right;">
          忘记密码(暂无短信服务，不可用)
        </router-link>
       <router-link :to="{ name: 'register'}" class="forge-password" style="float: right;margin-right: 10px" >
          注册账户
        </router-link> -->
      </a-form-item>
      <a-form-item style='margin-top:24px'>
        <a-button size='large'
                  type='primary'
                  htmlType='submit'
                  class='login-button'
                  :loading='loginBtn'
                  @click.stop.prevent='handleSubmit'
                  :disabled='loginBtn'>{{ $t('button.confirm') }}
        </a-button>
      </a-form-item>
      <!-- <div class="user-login-other">
        <span>其他登陆方式</span>
        <a @click="onThirdLogin('github')" title="github"><a-icon class="item-icon" type="github"></a-icon></a>
        <a @click="onThirdLogin('wechat_enterprise')" title="企业微信"><a-icon class="item-icon" type="wechat"></a-icon></a>
        <a @click="onThirdLogin('dingtalk')" title="钉钉"><a-icon class="item-icon" type="dingding"></a-icon></a>
      </div> -->
    </a-form>
    <two-step-captcha
      v-if='requiredTwoStepCaptcha'
      :visible='stepCaptchaVisible'
      @success='stepCaptchaSuccess'
      @cancel='stepCaptchaCancel'></two-step-captcha>
    <a-modal title='登录部门选择'
             :width='450'
             :visible='departVisible'
             :closable='false'
             :maskClosable='false'>
      <template slot='footer'>
        <a-button type='primary' @click='departOk'>确认</a-button>
      </template>
      <a-form>
        <a-form-item
          :labelCol='{span:4}'
          :wrapperCol='{span:20}'
          style='margin-bottom:10px'
          :validate-status='validate_status'>
          <a-tooltip placement='topLeft'>
            <template slot='title'>
              <span>您隶属于多部门，请选择登录部门</span>
            </template>
            <a-avatar style='backgroundColor:#87d068' icon='gold' />
          </a-tooltip>
          <a-select @change='departChange' :class="{'valid-error':validate_status=='error'}" placeholder='请选择登录部门' style='margin-left:10px;width: 80%'>
            <a-icon slot='suffixIcon' type='gold' />
            <a-select-option
              v-for='d in departList'
              :key='d.id'
              :value='d.orgCode'>
              {{ d.departName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <LoginSelectTenant ref='loginSelectTenant' @success='loginSuccess' />
  </div>
</template>

<script>
//import md5 from "md5"
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import Vue from 'vue'
import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
import { putAction, postAction, getAction } from '@/api/manage'
import { encryption, getEncryptedString } from '@/utils/encryption/aesEncrypt'
import store from '@/store/'
import { USER_INFO } from '@/store/mutation-types'
// import JSlider from '@/components/jeecg/JSlider'
import 'font-awesome/css/font-awesome.min.css'
import dragVerify from 'vue-drag-verify'
import LoginSelectTenant from '@views/user/LoginSelectTenant'
import { getLangList, randomImage, sysLanguageConfiguration } from '@api/api'

export default {
  components: {
    TwoStepCaptcha,
    // JSlider,
    dragVerify,
    LoginSelectTenant
  },
  data(){
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      encryptedString: {
        key: '',
        iv: ''
      },
      state: {
        time: 60,
        smsSendBtn: false
      },
      validatorRules: {
        // username:{rules: [{ required: true, message:  '请输入用户名!'},{validator: this.handleUsernameOrEmail}]},
        // password:{rules: [{ required: true, message: '请输入密码!',validator: 'click'}]},
        // mobile:{rules: [{validator:this.validateMobile}]},
        // captcha:{rule: [{ required: true, message: '请输入验证码!'}]},
        // inputCode:{rules: [{ required: true, message: '请输入验证码!'}]}
        username: { rules: [{ required: true, message: this.$t('label.pleaseEnterAUsername') }, { validator: this.handleUsernameOrEmail }] },
        password: { rules: [{ required: true, message: this.$t('label.pleaseEnterAPassword'), validator: 'click' }] },
        mobile: { rules: [{ validator: this.validateMobile }] },
        captcha: { rule: [{ required: true, message: this.$t('label.pleaseEnterTheVerificationCode') }] },
        inputCode: { rules: [{ required: true, message: this.$t('label.pleaseEnterTheVerificationCode') }] }
      },
      verifiedCode: '',
      inputCodeContent: '',
      inputCodeNull: true,

      departList: [],
      departVisible: false,
      departSelected: '',
      currentUsername: '',
      validate_status: '',
      currdatetime: '',
      randCodeImage: '',
      requestCodeSuccess: false,
      slidered: false,
      slideredMsg: '',
      defaultLocal: '',
      langList: []
    }
  },
  beforeCreate(){
    let url = process.env.VUE_APP_OATH_UTL
    if (typeof (url) != 'undefined') {
      window.location.href = url
    }
  },
  created(){
    this.currdatetime = new Date().getTime()
    Vue.ls.remove(ACCESS_TOKEN)
    this.getRouterData()
    this.handleChangeCheckCode()
    // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
    //this.getEncrypte();
    // update-end- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
    this.getLangLists()
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'PhoneLogin', 'ThirdLogin']),
    getLangLists(){
      sysLanguageConfiguration().then(res => {
        // validFlag
        let langList = res.result || []
        this.langList = []
        langList.map(item => {
          if (item.validFlag == 'Y') {
            this.langList.push(item)
          }
        })
        this.$ls.set('languageList', JSON.stringify(this.langList))
        this.defaultLocal = this.$ls.get('language', 'zh-cn')
      })
    },
    changeLang( e ){
      this.$bus.$emit('changeLang', e)
      this.defaultLocal = e
    },
    //第三方登录
    onThirdLogin( source ){
      let url = window._CONFIG[ 'domianURL' ] + `/thirdLogin/render/${ source }`
      window.open(url, `login ${ source }`, 'height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')
      let receiveMessage = event => {
        var origin = event.origin
        console.log('origin', origin)

        let token = event.data
        console.log('event.data', token)
        this.ThirdLogin(token).then(res => {
          if (res.success) {
            this.loginSuccess()
          } else {
            this.requestFailed(res)
          }
        })
      }
      window.addEventListener('message', receiveMessage, false)
    },
    // handler
    handleUsernameOrEmail( rule, value, callback ){
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    handleTabClick( key ){
      this.customActiveKey = key
      // this.form.resetFields()
    },
    // 点击登录按钮
    handleSubmit(){
      // 判断浏览器是否是谷歌或者火狐
      if (navigator.userAgent.toLowerCase().indexOf('chrome') == -1 && navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {
        return this.$message.warning(this.$t('label.pleaseUseChrome'))
      }
      if (!this.slidered) this.slideredMsg = this.$t('label.pleaseDragTheSlider')
      this.customActiveKey === 'tab1'? this.accountLogin(): this.phoneLogin()
    },
    // 用户名密码登录
    accountLogin(){
      if(!this.slidered) return false
      this.form.validateFields(['username', 'password',/*'inputCode',*/ 'rememberMe'], { force: true }, ( err, values ) => {
        this.loginBtn = false
        if (!err) {
          let loginParams = {
            username: values.username,
            password: values.password,
            remember_me: values.rememberMe,
            captcha: this.inputCodeContent,
            slidered: this.slidered,
            checkKey: this.currdatetime,
            mainLanguage: this.defaultLocal
          }
          // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
          //loginParams.password = md5(values.password)
          //loginParams.password = encryption(values.password,this.encryptedString.key,this.encryptedString.iv)
          // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
          this.loginBtn = true
          this.Login(loginParams).then(res => {
            this.loginBtn = false
            window._USER = res.result.userInfo
            // 已经选择公司了 就不需要弹框了
            if(!res.result.userInfo.orgCode){
              this.$refs.loginSelectTenant.show(res.result)
            }else{
              // 租户id存到缓存中
              this.$store.dispatch('saveTenant', res.result.userInfo.relTenantIds)
              this.loginSuccess()
            }
            // this.departConfirm(res)
          }).catch(err => this.requestFailed(err))
        }
      })
    },
    // 使用手机号登录
    phoneLogin(){
      this.form.validateFields(['mobile', 'captcha', 'rememberMe'], { force: true }, ( err, values ) => {
        if (!err) {
          let loginParams = {
            mobile: values.mobile,
            captcha: values.captcha,
            remember_me: values.rememberMe
          }
          this.loginBtn = true
          this.PhoneLogin(loginParams).then(( res ) => {
            this.loginBtn = true
            this.departConfirm(res)
          }).catch(err => this.requestFailed(err))
        }
      })
    },
    getCaptcha( e ){
      e.preventDefault()
      this.form.validateFields(['mobile'], { force: true }, ( err, values ) => {
          if (!values.mobile) {
            this.cmsFailed('请输入手机号')
          } else if (!err) {
            this.state.smsSendBtn = true
            let interval = window.setInterval(() => {
              if (this.state.time-- <= 0) {
                this.state.time = 60
                this.state.smsSendBtn = false
                window.clearInterval(interval)
              }
            }, 1000)
            const hide = this.$message.loading('验证码发送中..', 0)
            let smsParams = {}
            smsParams.mobile = values.mobile
            smsParams.smsmode = '0'
            postAction('/sys/sms', smsParams).then(res => {
              if (!res.success) {
                setTimeout(hide, 0)
                this.cmsFailed(res.message)
              }
              console.log(res)
              setTimeout(hide, 500)
            })
              .catch(err => {
                setTimeout(hide, 1)
                clearInterval(interval)
                this.state.time = 60
                this.state.smsSendBtn = false
                this.requestFailed(err)
              })
          }
        }
      )
    },
    stepCaptchaSuccess(){
      this.loginSuccess()
    },
    stepCaptchaCancel(){
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    handleChangeCheckCode(){
      this.currdatetime = new Date().getTime()
      randomImage(this.currdatetime).then(res => {
        if (res.success) {
          this.randCodeImage = res.result
          this.requestCodeSuccess = true
        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
    },
    // 初始化获取所有动态配置的多语言信息
    setLanguage() {
      getLangList().then(res => {
        let data = res.result
        this.$ls.set('dynamicLang', data)
        let zhObj = {}
        let enObj = {}
        let viObj = {}
        for (let i in data) {
          zhObj[ i ] = data[ i ].find(ele => ele.langType === 'zh-cn')?.langText || ''
          enObj[ i ] = data[ i ].find(ele => ele.langType === 'en-us')?.langText || ''
          viObj[ i ] = data[ i ].find(ele => ele.langType === 'vi-vn')?.langText || ''
        }
        // 接口获取的多语言配置合并本地的
        this.$i18n.mergeLocaleMessage('zh-cn', {
          dynamic: { ...zhObj }
        })
        // 接口获取的多语言配置合并本地的
        this.$i18n.mergeLocaleMessage('en-us', {
          dynamic: { ...enObj }
        })
        // 接口获取的多语言配置合并本地的
        this.$i18n.mergeLocaleMessage('vi-vn', {
          dynamic: { ...viObj }
        })
        console.log(this.$i18n.getLocaleMessage('en-us'), '多语言数据', data)
      })
    },
    loginSuccess(){
      this.setLanguage()
      // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      // this.loginBtn = false
      // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      this.$router.push({ path: '/dashboard/analysis' })
      this.$notification.success({
        message: this.$t('systemBase.welcome'),
        description: `${ timeFix(this) }，` + this.$t('systemBase.welcomeBack')
      })
    },
    cmsFailed( err ){
      this.$notification[ 'error' ]({
        message: this.$t('label.loginFailed'),
        description: err,
        duration: 4
      })
    },
    requestFailed( err ){
      this.loginBtn = false
    },
    validateMobile( rule, value, callback ){
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        callback()
      } else {
        callback('您的手机号码格式不正确!')
      }

    },
    validateInputCode( rule, value, callback ){
      if (!value || this.verifiedCode == this.inputCodeContent) {
        callback()
      } else {
        callback('您输入的验证码不正确!')
      }
    },
    generateCode( value ){
      this.verifiedCode = value.toLowerCase()
    },
    inputCodeChange( e ){
      this.inputCodeContent = e.target.value
    },
    departConfirm( res ){
      let multi_depart = res.result.multi_depart
      //0:无部门 1:一个部门 2:多个部门
      if (multi_depart == 0) {
        this.loginSuccess()
        this.$notification.warn({
          message: this.$t('tip.tips'),
          description: this.$t('tip.YouDoNotBelongToTheDepartmentPleaseConfirmTheAccountInformation'),
          duration: 3
        })
      } else {
        this.loginSuccess()
      }
    },
    departOk(){
      if (!this.departSelected) {
        this.validate_status = 'error'
        return false
      }
      let obj = {
        orgCode: this.departSelected,
        username: this.form.getFieldValue('username')
      }
      putAction('/sys/selectDepart', obj).then(res => {
        if (res.success) {
          const userInfo = res.result.userInfo
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          store.commit('SET_INFO', userInfo)
          //console.log("---切换组织机构---userInfo-------",store.getters.userInfo.orgCode);
          this.departClear()
          this.loginSuccess()
        } else {
          this.requestFailed(res)
          this.Logout().then(() => {
            this.departClear()
          })
        }
      })
    },
    departClear(){
      this.departList = []
      this.departSelected = ''
      this.currentUsername = ''
      this.departVisible = false
      this.validate_status = ''
    },
    departChange( value ){
      this.validate_status = 'success'
      this.departSelected = value
    },
    getRouterData(){
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            'username': this.$route.params.username
          })
        }
      })
    },
    //获取密码加密规则
    getEncrypte(){
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING)
      if (encryptedString == null) {
        getEncryptedString().then(( data ) => {
          this.encryptedString = data
        })
      } else {
        this.encryptedString = encryptedString
      }
    },/*滑块验证*/
    sliderSuccess(){
      this.slidered = true
      this.slideredMsg = ''
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .ant-select-lg .ant-select-selection__rendered {
  margin-left: 33px;
}
.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}

.dv_handler {
  height: 34px !important;
  border: none !important;

  .fa {
    position: relative;
    top: 2px;
  }
}

.login-page {
  .ant-select-selection-selected-value {
    margin-left: 20px !important;
  }
}

.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, .2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color .3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>